import React, { useState } from 'react';
import { Tab, TabList } from 'react-tabs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { COMMON_GENIE_SORT } from '../../../hooks/useGenieMessagesSort';
import useLocalSort from '../../../hooks/useLocalSort';
import FormSection from '../../../genie/components/form-section/FormSection';
import GenerateMessagesForm from '../../../genie/components/generate-messages/generate-messages-form/GenerateMessagesForm';
import SortField from '../../../genie/components/sort-field/SortField';
import MessagesList from '../../../genie/components/messages-list/MessagesList';
import GeneratedMessage from '../../../genie/components/generate-messages/generated-message/GeneratedMessage';
import { GENIE_EVALUATE_TYPE, PROJECT_TYPES } from '../../../constants';

import scss from './GenerateMessages.module.scss';

function GenerateMessages({ onGenerateMessages, onReply, onResetSession, onFileUpload }) {
  const { t } = useTranslation('genie');

  const [isShowForm, setIsShowForm] = useState(true);
  const [sort, setSort] = useState(COMMON_GENIE_SORT);

  const messages = useSelector((state) => state.genieGo.messages);
  const isFormLoading = useSelector((state) => state.genieGo.isFormLoading);
  const evaluateActions = useSelector((state) => state.genieGo.evaluateActions);

  const sortedMessages = useLocalSort({ content: messages, sort: sort });

  const handleChangeForVisibility = () => {
    setIsShowForm((prevState) => !prevState);
  };

  const handleChangeSort = ({ sort, direction, getSortValue }) => {
    setSort({ sort, direction, getSortValue });
  };

  return (
    <div className={scss.sectionWrapper}>
      <TabList className={scss.tabList}>
        <Tab selected>{t('generateNew')}</Tab>
      </TabList>

      <FormSection
        isShowForm={isShowForm}
        onChangeVisibility={handleChangeForVisibility}
        hideLabel={t('generateMessagesForm')}>
        <GenerateMessagesForm
          onGenerateMessages={onGenerateMessages}
          onReply={onReply}
          onResetSession={onResetSession}
          onFileUpload={onFileUpload}
          projectType={PROJECT_TYPES.GENIE_GO}
        />
      </FormSection>

      <SortField onSortChange={handleChangeSort} sort={sort} disabled={isFormLoading} />

      <MessagesList
        content={sortedMessages}
        className={scss.listWrapper}
        renderMessage={(message) => (
          <GeneratedMessage
            key={`${message.message}-${message.count}`}
            message={message}
            isLoading={evaluateActions[GENIE_EVALUATE_TYPE.GENERATED].pending}
          />
        )}
        isLoading={isFormLoading}
      />
    </div>
  );
}

export default GenerateMessages;
